export const ROLE_HOME = {
  admin: "/app",
  kursleitung: "/app",
  firma: "/schulungen/firma",
  teilnehmer: "/schulungen/teilnehmer",
  mitarbeiter: "/mitarbeiter",
  teamleitung: "/app",
};

export const homeForRole = (role) => ROLE_HOME[role] || "/schulungen/login";

export const authHeaders = (user) => ({ headers: { Authorization: `Bearer ${user.token}` } });

export const PREIS_PRO_PLATZ = 180;

export const BESTELL_STATUS = {
  offen: { label: "Offen – Rechnung folgt", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  rechnung_gestellt: { label: "Rechnung gestellt", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  bezahlt: { label: "Bezahlt", cls: "bg-green-50 text-green-700 border-green-200" },
  storniert: { label: "Storniert", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export const EINLADUNG_STATUS = {
  offen: { label: "Offen", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  eingeloest: { label: "Eingelöst", cls: "bg-green-50 text-green-700 border-green-200" },
  abgelaufen: { label: "Abgelaufen", cls: "bg-red-50 text-red-700 border-red-200" },
  widerrufen: { label: "Widerrufen", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export const KONTAKT = { name: "Karsten Weinacht", rolle: "Kursleitung & Ansprechpartner", telefonAnzeige: "0163 791 7044", telefon: "+491637917044", whatsapp: "491637917044", email: "lehnenundweinacht@gmail.com" };

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("de-DE") : "–");
export const fmtEur = (n) => `${Number(n || 0).toLocaleString("de-DE")} €`;
export const fmtDatum = (ymd) => (ymd ? new Date(`${ymd}T00:00:00`).toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" }) : "–");

export async function downloadZertifikat(user, teilnehmerId, name = "Zertifikat") {
  const axios = (await import("axios")).default;
  const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/schulungen/teilnehmer/${teilnehmerId}/zertifikat.pdf`, { ...authHeaders(user), responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url; a.download = `${name.replace(/\s+/g, "_")}.pdf`; a.target = "_blank";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export function formatApiErrorDetail(detail, fallback = "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
